<template>
  <div>
    <div class="checkin__last-call  checkin__last-call--det d-block d-md-flex align-items-center justify-content-between">
      <div class="mb-2 mb-md-0">
        <Icon name="infoCircle" width="20" class="mr-2"/>
         {{ $t('pages.checkins.media_deleted') }}
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "InfoMediaDeleted",
}
</script>

<style scoped>

</style>